export default "__VITE_ASSET__M1fkEueB__"